import * as React from "react";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import { formatMessage } from "lib/globalize-util";
import { $, merge } from "glamor";
import theme from "styles/theme";

interface ICheckboxListHeaderProps {
    areAllSelected: boolean;
    isIndeterminate: boolean;
    onToggle: (allSelected: boolean) => () => void;
}

const styles = merge(
    $(" .MuiCheckbox-colorSecondary.Mui-checked", {
        color: theme.palette.accent1Color,
    }),
    $(" .MuiCheckbox-root", {
        color: theme.palette.accent1Color,
    })
);

export const CheckboxListHeader: React.FC<ICheckboxListHeaderProps> = ({
    areAllSelected,
    isIndeterminate,
    onToggle,
}) => {
    return (
        <div {...styles}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={areAllSelected}
                        indeterminate={!areAllSelected && isIndeterminate}
                        onChange={onToggle(areAllSelected)}
                    />
                }
                label={formatMessage("All")}
            />
        </div>
    );
};
